import { render, staticRenderFns } from "./introductionPopup.vue?vue&type=template&id=2fe71866&scoped=true&"
import script from "./introductionPopup.vue?vue&type=script&lang=js&"
export * from "./introductionPopup.vue?vue&type=script&lang=js&"
import style0 from "./introductionPopup.vue?vue&type=style&index=0&id=2fe71866&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe71866",
  null
  
)

export default component.exports